import { Injectable } from '@angular/core';
import { Router, RouterEvent, NavigationEnd, ActivatedRoute } from '@angular/router';

/** A router wrapper, adding extra functions. */
@Injectable()
export class RouterExtService {

	private lastNonOverlay: string = '/';

	constructor(private router: Router,
		private activeRoute: ActivatedRoute) {
		router.events.subscribe(event => {
			if (event instanceof NavigationEnd) {
				var a = this.activeRoute;
				while (a.children.length > 0) {
					a = a.children[0];
				}

				if (!a.snapshot.data.isOverlay) {
					this.lastNonOverlay = event.url;
				}
			};
		});
	}

	public closeOverlay() {
		console.log('going to: ' + this.lastNonOverlay)

		return this.router.navigateByUrl(this.lastNonOverlay);
	}
}